<article class="product-card">
  <figure class="product-card__figure" [class.is--loading]="!product" [class.is--sold-out]="!product?.availableForSale">
    <!--<span
      class="chip-label type-body-sm text-uppercase chip--primary chip--outline product-card__figure__label"
      *ngIf="!product?.availableForSale"
    >
      {{ 'product-tegel-uitverkocht-label' | fromDictionary }}
    </span>-->
    @defer (hydrate on idle) {
      <app-product-image-slider
        [showVideos]="false"
        [product]="product"
        [hasLink]="true"
        [showVariantImages]="true"
        [collectionHandle]="collectionHandle"
        [sizes]="sizes"
        [showPagination]="false"
        [initOnInteraction]="true"
      ></app-product-image-slider>
    }

    <!--<div class="product-card__figure__slider fade-in" *ngIf="showSlider && (product?.images?.length || 0) > 1; else singleImage">
      <app-product-image-slider [product]="product" [collectionHandle]="collectionHandle"></app-product-image-slider>
    </div>

    <ng-template #singleImage>
      <a [routerLink]="collectionHandle ? [product?.handle] : ['/', 'products', product?.handle]" [queryParams]="getFirstColor()">

        <img
          *ngIf="(!showSlider || (product?.images?.length || 1) < 2) && product?.images?.[0]?.url"
          [src]="product?.images?.[0]?.url"
          [alt]="product?.images?.[0]?.altText || product?.title"
          class="product-image product-image-ratio fade-in"
        />
        <img
          *ngIf="product && !product?.images?.[0]?.url"
          [src]="'product-placeholder-afbeelding' | fromDictionary"
          [alt]="product.images?.[0]?.altText || product.title"
          class="product-image product-image-ratio fade-in"
        />
      </a>
    </ng-template>-->
  </figure>

  <main class="product-card__content mt-2" [class.is--sold-out]="!product?.availableForSale">
    <div class="product-card__content__text">
      <a class="link link--dark" [routerLink]="collectionHandle ? [product?.handle] : ['/', 'products', product?.handle]">
        <h2 class="product-card__content__title h5 mb-0 fw-normal">
          {{ product?.title || productPreview?.title }}
        </h2>
      </a>
      <span class="type-body-sm">{{ product?.productType }}</span>
      <!-- <span class="type-body-sm" *ngIf="product?.collections">
        {{ collectionsAsText(product?.collections) }}
      </span> -->
    </div>

    <!-- <strong *ngIf="product?.compareAtPriceRange?.maxVariantPrice.amount > 0"><del>{{ product?.compareAtPriceRange?.maxVariantPrice.amount | currency: 'EUR'}}</del></strong> -->

    <div class="product-card__content__meta type-body-md" *ngIf="product?.priceRange?.minVariantPrice as minPrice">
      <small class="me-1 type-body-xs">{{ 'product-card-vanaf-prijf-prefix' | fromDictionary }}</small>

      <ng-container *ngIf="product?.compareAtPriceRange?.minVariantPrice as comparePrice; else elseDiscountBlock">
        <div *ngIf="+comparePrice.amount > +minPrice.amount; else elseDiscountBlock" class="d-inline-flex flex-column">
          <del class="product-card__discount-before-price price--old type-body-xs">
            {{ comparePrice.amount | currency: comparePrice.currencyCode }}
          </del>
          <strong class="price--new">{{ minPrice?.amount | currency: minPrice.currencyCode }}</strong>
        </div>
      </ng-container>
      <ng-template #elseDiscountBlock>{{ minPrice?.amount | currency: minPrice.currencyCode }}</ng-template>
    </div>
  </main>
  <ul class="swatch-list swatch-list--sm mt-2-5">
    <li class="swatch-list__item" *ngFor="let colorLabel of getColorOption()?.values; let i = index">
      <a
        class="swatch"
        [style.--swatch-color]="getColorForOption(colorLabel)"
        [class.is--white]="['white', '#fff', '#ffffff'].includes(getColorForOption(colorLabel) || '')"
        [routerLink]="collectionHandle ? [product?.handle] : ['/', 'products', product?.handle]"
        [queryParams]="{ Color: colorLabel }"
      ></a>
    </li>
  </ul>
</article>
